// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MyInfo_wrapper__2l_ZQ","title":"MyInfo_title__2OedP","message":"MyInfo_message__2zhPT","info":"MyInfo_info__1wNXS"};